import { cn } from '@mntn-dev/ui-utilities'
import type { IconProps } from '../../icon/icon.tsx'
import type { ModalCenteredHeaderIconProps } from '../organisms/modal-centered-header/modal-centered-header-icon.tsx'
import { ModalCenteredHeader } from '../organisms/modal-centered-header/modal-centered-header.tsx'

export type HeaderIconProps = Partial<
  Omit<ModalCenteredHeaderIconProps, 'className' | 'name'>
> &
  Pick<IconProps, 'name'>
export type FormModalHeaderProps = {
  className?: string
  icon?: HeaderIconProps
  title: string
}

const defaultIconProps: Omit<
  ModalCenteredHeaderIconProps,
  'className' | 'name'
> = {
  color: 'info',
  fill: 'outline',
}

export const FormModalHeader = ({
  className,
  icon: iconProp,
  title,
}: FormModalHeaderProps) => {
  const icon: IconProps | undefined = iconProp
    ? { size: '4xl', ...defaultIconProps, ...iconProp }
    : undefined

  return (
    <ModalCenteredHeader className={cn('pt-6 px-8', className)}>
      {icon && <ModalCenteredHeader.Icon {...icon} className="my-4" />}
      <ModalCenteredHeader.Title>{title}</ModalCenteredHeader.Title>
    </ModalCenteredHeader>
  )
}
